"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_AGREEMENTS_MODAL_CONTENT = void 0;
exports.CREDIT_BUILDER_AGREEMENTS_MODAL_CONTENT = {
    HEADER: 'Complete signup',
    BODY: 'To finish signing up, just review the following legal information.',
    SUB_HEADER: 'By choosing ‘Accept’, I agree to:',
    BACK: 'Go back',
    CTA: 'Accept'
};
